import React, { Component } from "react";
import { TextInputSkeleton } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import "carbon-components/scss/components/notification/_inline-notification.scss";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import { editCreatives } from "../../Flux/Actions/CreativesActions";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "../Modals/ModalHelpers";
import CreativesDataStore from "../../Flux/Stores/CreativesDataStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import "./modal.scss";
import moment from "moment";
import Loading from "../../Components/LoadingSpinner";
import Button from "@acadia-ui/button";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	isFormDataValid: false
};

const formEl = "edit_creative";

class EditCreative extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: moment(this.props.metaData.StartDate).format("YYYY/MM/DD"),
				EndDate: moment(this.props.metaData.EndDate).format("YYYY/MM/DD")
			},
			loading: false,
			...initialState
		};
	}

	componentDidMount() {
		this.props.editCreative(this);
		CreativesDataStore.on("creatives_edit_fail", this.handleErrors);
		CreativesDataStore.on("creative__errors__reset", this.handleReset);
		CreativesDataStore.on("creatives_edit_success", this.handleSuccess);
	}

	componentWillUnmount() {
		this.props.editCreative(undefined);
		CreativesDataStore.removeListener("creatives_edit_fail", this.handleErrors);
		CreativesDataStore.removeListener("creative__errors__reset", this.handleReset);
		CreativesDataStore.removeListener("creatives_edit_success", this.handleSuccess);
	}

	handleSuccess = () => {
		this.setState({ loading: false }, () => {
			this.triggerOpenClose();
			showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Creative updated successfully." timed={5000} />);
		});
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = CreativesDataStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const creativeErrors = errors;
				const type = "edit creative";
				this.setState({ errors: creativeErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Creative could not be updated." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				if (!this.state.open) {
					const modals = document.getElementsByClassName("bx--modal-content");
					if (this.props.config) {
						const fieldCount =
							this.props.config.CreativeData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length +
							this.props.config.TaxonomyData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length +
							this.props.config.MetaData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length;
						if (modals) {
							if (fieldCount <= 8) {
								for (const modal of modals) {
									if (modal.style.overflow !== "visible") {
										modal.style.overflow = "visible";
									}
								}
							} else {
								for (const modal of modals) {
									if (modal.style.overflow !== "auto") {
										modal.style.overflow = "auto";
									}
								}
							}
						}
					}
					this.setState({ loading: true }, () => {
						this.fillFields();
					});
				}
			});
		}
	};

	handleParentReset = (callback) => {
		// console.log('STATE', this.state);
		if (callback) {
			this.setState({ ...initialState }, callback());
		} else {
			this.setState({ ...initialState });
		}
	};

	fillFields = () => {
		this.handleParentReset();
		this.matchData();
		this.setState({ loading: false });
	};

	matchData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		const dataFieldsArray = [];
		for (const dataBucket of configObjs) {
			if (dataBucket[0] !== "ParentData" && dataBucket[0] !== "ChildData") {
				for (const field of dataBucket[1]) {
					if (this.props.data !== undefined) {
						if (this.props.data.hasOwnProperty(field.Name)) {
							setTimeout(() => {
								if (field.DataType === "Select") {
									let optionID = this.props.data[`${field.Name}ID`];
									let fieldLabel = this.props.data[field.Name];
									const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
									if (fieldItem.length > 0) {
										const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == this.props.data[field.Name]);
										if (optionItem.length > 0) {
											optionID = optionItem[0].OptionID;
										}
									}

									if (optionID === undefined) {
										let dataValueID = null;
										const previousTaxonomyData =
											this.props.data.TaxonomyData && this.props.data.TaxonomyData !== "" ? JSON.parse(this.props.data.TaxonomyData) : [];
										const previousMetaData = this.props.data.MetaData && this.props.data.MetaData !== "" ? JSON.parse(this.props.data.MetaData) : [];
										previousTaxonomyData.forEach((taxonomyField) => {
											if (taxonomyField.DataKeyShortDescr === field.Label) {
												dataValueID = taxonomyField.DataValue.DataValueID;
											}
										});
										if (dataValueID === null) {
											previousMetaData.forEach((metaDataField) => {
												if (metaDataField.DataKeyShortDescr === field.Label) {
													dataValueID = metaDataField.DataValue.DataValueID;
												}
											});
										}
										if (dataValueID !== null) {
											const changedMatchingOption = field.Options.filter((option) => option.OptionID === dataValueID.toString());
											if (changedMatchingOption[0] !== undefined) {
												optionID = changedMatchingOption[0].OptionID;
												fieldLabel = changedMatchingOption[0].OptionLabel;
											}
										}
									}

									// Populate Drop Down Fields
									// There are only 7 Parameters accepted: see updateState below to match
									if (optionID != undefined && optionID > 0) {
										dataFieldsArray.push([dataBucket[0], field.Name, { value: optionID, label: fieldLabel }, field.ID, field.DataType, false, false]);
									}
								} else {
									// Populate Free Text Fields
									// There are only 7 Parameters accepted: see updateState below to match
									dataFieldsArray.push([dataBucket[0], field.Name, this.props.data[field.Name], field.ID, field.DataType, false, false]);
								}
							}, 0);
						}
					}
				}
			}
		}
		setTimeout(() => {
			this.updateStatev2(dataFieldsArray);
		}, 100);
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState });
	};
	/* END */

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled) {
					isValid = false;
				}
			}
		}

		this.setState({ isFormDataValid: isValid });
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		if (this.state.loading === false) {
			// The reference to THIS is used to update the proper state
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, true, formEl, this, disabled, this.props.config, false, this.isValidFormData());
		}
	};

	updateStatev2 = (dataFieldsArray) => {
		if (this.state.loading === false) {
			UpdateStateHelper.updatev2(dataFieldsArray, formEl, this, this.props.config);
		}
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}

			postData.MetaData = strippedMetadataPostData;

			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			postData.CreativeData.MasterCampaignID = this.props.data.MasterCampaignID;
			postData.CreativeData.CampaignID = this.props.data.CampaignID;
			postData.CreativeData.CreativeID = this.props.data.CreativeID;
			postData.CreativeData.UniqueID = this.props.data.UniqueID;
			// const MasterUniqueCodeID = MasterCampaignsStore.getMasterUniqueID();
			/* Config will hold the ID's of the filters */
			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			// const auditlevelID = filters.auditlevel.value;

			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};

			// console.log(formSubmissionObj);
			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();

				/* Server Side Validation */
				this.sendPostObject(this.state.formData);
			});
		}
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			if (!this.postObject.CreativeData) {
				this.postObject.CreativeData = {
					UniqueID: 1
				};
			}
			const arrayPostObject = [this.postObject];
			editCreatives(arrayPostObject);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	render() {
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		const isDisabled = this.state.loading ? "disabledModal" : "";
		let formInnards;
		if (this.props.config) {
			if (Object.keys(this.props.config).length !== 0) {
				formInnards = <FormBuilderV2 type="edit creative" data={this.props.config} configName="creativesConfig" onUpdate={this.updateState} state={this.state} />;
			} else {
				formInnards = (
					<div>
						<TextInputSkeleton />
						<br />
						<TextInputSkeleton hideLabel />
					</div>
				);
			}
		}

		return (
			<>
				<Modal
					id={formEl}
					className={`create--creative ${isDisabled}`}
					heading="Edit Creative"
					description="You can make edits inline, then click the 'Save' button to save the changes."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-edit-creative">
									Cancel
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-edit-creative"
								>
									Save
								</Button>
							</>
						)
					}}
				>
					{this.state.loading ? (
						<Loading className="modalLoading" />
					) : (
						<form autoComplete="off">
							<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
							{this.state.showErrors && <div id="errors__container" />}
						</form>
					)}
				</Modal>
			</>
		);
	}
}

export default EditCreative;
